@if (showUI()) {
  <app-multiple-select
    (selectDataEvent)="filtersStore.patchFilters({ deviceType: $event })"
    [options]="filtersStore.deviceTypeOptions()"
    [value]="filtersStore.deviceType()"
    label="Device Type"
    panelClass="wide-overlay"
    selectClass="stroked-select-multiple"
  />

  <app-multiple-select
    (selectDataEvent)="filtersStore.patchFilters({ deviceMaker: $event })"
    [options]="filtersStore.deviceMakerOptions()"
    [value]="filtersStore.deviceMaker()"
    label="Manufacturer"
    panelClass="assigned-user-overlay"
    selectClass="stroked-select-multiple"
  />

  @if (config().building || config().floor) {
    <avs-li-location-filters
      (filtersChanged)="filtersStore.patchFilters($event)"
      [config]="{
        building: config().building,
        floor: config().floor,
        options: {
          building: filtersStore.locationOptions(),
          floor: filtersStore.floorOptions(),
          room: filtersStore.roomOptions(),
        }
      }"
      [filters]="{
        building: filtersStore.building(),
        floor: filtersStore.floor(),
        room: filtersStore.room(),
      }"
    />
  }

  @if (hasSelectedFilters()) {
    <button
      class="test-clear-all-filters text-sm text-ui-dark font-normal underline h-9 ml-3"
      (click)="clearFilters()"
    >
      Clear All
    </button>
  }
}
